import React from 'react';
import { Popover, PopoverProps } from 'antd';

/**
 * Custom Popover wrapper
 */
export interface MyPopoverProps extends PopoverProps {
  variant?: 'default' | 'light' | 'dark';
}

const MyPopover: React.FC<MyPopoverProps> = ({
  variant = 'default',
  overlayStyle,
  children,
  ...rest
}) => {
  const variantStyles: Record<string, React.CSSProperties> = {
    default: {},
    light: {
      background: '#fff',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    },
    dark: {
      background: '#1f1f1f',
      color: '#fff',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
    },
  };

  const customOverlayStyle: React.CSSProperties = {
    ...variantStyles[variant],
    borderRadius: '8px',
    ...overlayStyle,
  };

  return (
    <Popover overlayStyle={customOverlayStyle} {...rest}>
      {children}
    </Popover>
  );
};

export default MyPopover;
